export default {
    props: {
        timeRange: {
            type: String,
            default: '',
            validator(val) {
                return ['year', 'month', ''].indexOf(val) >= 0
            }
        },
        orderDataSource: {
            type: String,
            default: '',
            validator(val) {
                return ['G', 'R', ''].indexOf(val) >= 0
            }
        }
    },

    computed: {
        timeRangeText() {
            if (this.timeRange == 'year') {
                return "本年"
            }

            if (this.timeRange == 'month') {
                return "本月"
            }
        },

        dataSourceText() {
            if (this.orderDataSource == 'G') {
                return "工单"
            }

            if (this.orderDataSource == 'R') {
                return "任务"
            }
        },
    }
}